export const NEW_TAB_PROPS = { target: '_blank', rel: 'noreferrer' };
